const JobTableHeaderLabels = {
  name: "JOB NAME",
  status: "STATUS",
  lastRun: "LAST RUN"
};

module.exports = JobTableHeaderLabels;



// WEBPACK FOOTER //
// ./src/js/constants/JobTableHeaderLables.js